import { AuthGuard } from "@redotech/redo-customer-portal-app/contexts/auth";
import { Outlet, RouteObject } from "react-router-dom";
import { Page } from "../page";
export const giftReceiptRoutes: RouteObject[] = [
  {
    element: (
      <AuthGuard>
        <Page>
          <Outlet />
        </Page>
      </AuthGuard>
    ),
    children: [
      {
        path: "router",
        lazy: async () => {
          const { Router } =
            await import("@redotech/redo-customer-portal-app/portal-four/orders/gift-receipts/router");
          return { Component: Router };
        },
      },
      {
        path: "manage",
        lazy: async () => {
          const { Manage } =
            await import("@redotech/redo-customer-portal-app/portal-four/orders/gift-receipts/manage/manage");
          return { Component: Manage };
        },
      },
      {
        path: "create",
        lazy: async () => {
          const { Dispatcher } =
            await import("@redotech/redo-customer-portal-app/portal-four/orders/gift-receipts/create-gift-receipt/dispatcher/dispatcher");
          return { Component: Dispatcher };
        },
      },
      {
        path: ":receiptId",
        lazy: async () => {
          const { Details } =
            await import("@redotech/redo-customer-portal-app/portal-four/orders/gift-receipts/details/details");
          return { Component: Details };
        },
      },
    ],
  },
];
